import { faPartyHorn, faAlarmExclamation, faCheck, faTriangleExclamation, faEye } from '@fortawesome/pro-light-svg-icons'
import { RowData } from '../../../../baseComponents/TwinTable/types'
import TwinIcon, { TwinIconToolTip } from '../../../../baseComponents/TwinIcon'
import TwinTrans from '../../../../baseComponents/TwinTrans'
import { displayFormatedHourFromMins, getMinFromHoursMin } from '../../../../utils/globals/date'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { parseStartAndEndTime } from '../functions'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { SetEditDeleteModalTy } from '../../../../utils/hooks/useEditDeleteModal'
import { useCallback } from 'react'

interface RenderDateAndWeekDayProps {
    date: string
}

export const RenderDateAndWeekDay: React.FC<RenderDateAndWeekDayProps> = ({ date }) => {
    if(date === ''){
        return(
        <div className='uppercase'>
            <TwinTrans transKey='total'>Total</TwinTrans>
        </div>
        )
    }
    const parsedDate = new Date(date)
    return (
        <div>
            <span className='w-20 inline-block text-right mr-15'>{parsedDate.getDate()}</span>
            <span className='capitalize'>{parsedDate.toLocaleDateString(undefined, { weekday: 'long' })}</span>
        </div>
    )
}
interface ControlEmployeesRenderProps {
    allRowData: RowData

}
interface RenderWorkingTimeProps extends ControlEmployeesRenderProps {
}

export const RenderWorkingTime: React.FC<RenderWorkingTimeProps> = ({ allRowData }) => {
    if(!allRowData.journey){
        let extraInfo: JSX.Element | null = null
        if(allRowData.type === 'freeDay'){
            extraInfo = (
                <div className='flex items-center justify-between'>
                    <span className='mx-10 h-24 border-l border-gray-97'></span>
                    <TwinIcon className='mr-8' icon={faPartyHorn} /><TwinTrans transKey='exFreeDay'>¡Día festivo!</TwinTrans>
                </div>
            )
        } else if(allRowData.type === 'holidayDay'){
            extraInfo = (
                <div className='flex items-center justify-between'>
                    <span className='mx-10 h-24 border-l border-gray-97'></span>
                    <TwinIcon className='mr-8' icon={faPartyHorn} /><TwinTrans transKey='exHoliday'>¡Vacaciones!</TwinTrans>
                </div>
            )
        } else if(allRowData.type === 'totals'){
            return <div></div>
        }
        return (
            <div className='flex items-center'>
                <span>
                    <TwinTrans transKey='registerNotExpected'>No se espera registro</TwinTrans>
                </span>
                {extraInfo}
            </div>
        )
    }
    const renderThis: JSX.Element[] = []
    if(allRowData.journey.workingTime){
        for (const key in allRowData.journey.workingTime) {
            const hours = allRowData.journey.workingTime[key]
            const isOvertime = allRowData.journey?.overtimePosition?.includes(parseInt(key))
            renderThis.push(
                <div key={key}>
                    <span><TwinTrans transKey='fromShort'>De</TwinTrans> </span>
                    {displayFormatedHourFromMins(hours[0])}
                    <span> <TwinTrans transKey='aTo'>a</TwinTrans> </span>
                    {displayFormatedHourFromMins(hours[1])}
                    {isOvertime ? <span> (<TwinTrans transKey='extra'>Extra</TwinTrans>)</span> : null}
                </div>
            )
        }
    }
    return (
        <div className={'flex flex-col overflow-y-auto flex-auto h-full ' + (allRowData?.journey?.workingTime?.length > 2 || allRowData?.journey?.overtimePosition?.length > 2 ? '' : 'justify-center')}>
            {renderThis}
        </div>
    )
}

interface RenderWorkingCenterEntryProps extends ControlEmployeesRenderProps {
    permittedHours?: boolean
}

export const RenderWorkingCenterEntry: React.FC<RenderWorkingCenterEntryProps> = ({ allRowData, permittedHours }) => {
    if (!allRowData.journey) {
        return <div></div>
    }
    const renderThis: JSX.Element[] = []
    let sameWorkingCenter: boolean = true
    let lastWorkingCenterId: number | null = null
    if (allRowData?.dividedByTurns) {
        for (const turn of allRowData.dividedByTurns) {
            if ((lastWorkingCenterId && lastWorkingCenterId !== turn?.WorkingCenterId) || !turn?.WorkingCenterId) {
                sameWorkingCenter = false
            }
            lastWorkingCenterId = turn?.WorkingCenterId
            if (turn?.workingTime && turn?.workingTime?.length) {
                for (const key in turn?.workingTime) {
                    renderThis.push(<div key={turn.TurnId + key}><div className='twin_elipsis' title={turn?.workingCenterName}>{turn?.workingCenterName}</div></div>)
                }
            }
        }
    } else if (allRowData?.timetables) {
        for (const key in allRowData.timetables) {
            const timetable = allRowData.timetables[key]
            if ((lastWorkingCenterId && lastWorkingCenterId !== timetable?.WorkingCenterId) || !timetable?.WorkingCenterId) {
                sameWorkingCenter = false
            }
            lastWorkingCenterId = timetable?.WorkingCenterId
            if (!permittedHours || (permittedHours && timetable?.workingTimePermitted?.length)) {
                renderThis.push(<div key={key}><div className='twin_elipsis' title={timetable?.WorkingCenter?.name}>{timetable?.WorkingCenter?.name}</div></div>)
            }
        }
    }

    return (
        <div className={'flex flex-col overflow-y-auto flex-auto h-full ' + (!sameWorkingCenter && renderThis.length > 1 ? 'pt - 12' : 'justify-center')}>
            {sameWorkingCenter ? renderThis[0]: renderThis}
        </div>
    )
}
interface RenderEntryOutWorkProps extends ControlEmployeesRenderProps {
    entry: boolean
}

export const RenderEntryOutWork: React.FC<RenderEntryOutWorkProps> = ({ allRowData, entry }) => {
    if (!allRowData.journey) {
        return <div></div>
    }
    const renderThis: JSX.Element[] = []
    if (allRowData?.timetables) {
        for (const key in allRowData.timetables) {
            const timetable = allRowData.timetables[key]
            const { startMin, endMin } = parseStartAndEndTime(timetable)
            const value = entry ? startMin : endMin
            if (value === 0 && !entry) {
                renderThis.push(<div key={key}>-</div>)
            } else {
                renderThis.push(<div className={entry ? timetable.edited_start_time ? 'text-yellow-B9' : '' : timetable.edited_end_time? 'text-yellow-B9' : ''} key={key}>{displayFormatedHourFromMins(value)}</div>)
            }
        }
    }
    return (
        <div className={'flex flex-col overflow-y-auto flex-auto h-full justify-center'+ (allRowData?.timetables?.length > 2 ? 'pt - 12' : '')}>
            {renderThis}
        </div>
    )
}
interface RenderEntryOutWorkPermittedProps extends ControlEmployeesRenderProps {
    entry: boolean
}

export const RenderEntryOutWorkPermitted: React.FC<RenderEntryOutWorkPermittedProps> = ({ allRowData, entry }) => {
    if (!allRowData.journey) {
        return <div></div>
    }
    const renderThis: JSX.Element[] = []
    if(allRowData?.timetables){
        for (const key in allRowData?.timetables) {
            const timetable = allRowData?.timetables[key]
            const workingTimePermittedArray = timetable?.workingTimePermitted
            let value = null
            if (workingTimePermittedArray?.length) {
                for (const workingTimePermitted of workingTimePermittedArray) {
                    value = entry ? workingTimePermitted[0] : workingTimePermitted[1]
                    if (value === null) {
                        continue
                    } else if (value === 0 && !entry) {
                        renderThis.push(<div key={key}>-</div>)
                    } else {
                        renderThis.push(<div key={key} className={ entry? timetable.edited_start_time ? 'text-yellow-B9' : '' : timetable.edited_end_time ? 'text-yellow-B9' : '' }>{displayFormatedHourFromMins(value)}</div>)
                    }
                }
            }
        }
    }
    return (
        <div className={'flex flex-col overflow-y-auto flex-auto h-full ' + (allRowData?.timetablesPermitted?.length > 2 ? 'pt - 12' : '') + (renderThis?.length > 2 ? 'justify-start' : 'justify-center')}>
            {renderThis}
        </div>
    )
}



interface RenderWorkedHoursProps extends ControlEmployeesRenderProps {
    permittedTime: boolean
}


export const RenderWorkedHours: React.FC<RenderWorkedHoursProps> = ({ allRowData, permittedTime }) => {
    if (!allRowData?.journey && allRowData.type !== 'totals') {
        return <div></div>
    }
    let workedHours = 0
    if (allRowData?.totalDayTime) {
       workedHours = allRowData?.totalDayTime
    }
    if (allRowData.type === 'totals') {
        workedHours = allRowData?.totalMinsWorked || 0
    }
    if(permittedTime){
        workedHours = allRowData?.totalMinsPermittedWorked || 0
    }
    return (
        <div>
            {displayFormatedHourFromMins(workedHours)}
        </div>
    )
}

interface RenderHoursToWorkProps extends ControlEmployeesRenderProps {
}


export const RenderHoursToWork: React.FC<RenderHoursToWorkProps> = ({ allRowData }) => {
    if (!allRowData?.journey && allRowData.type !== 'totals') {
        return <div></div>
    }
    if (allRowData?.isHalfDay) {
        return <span><TwinTrans transKey='halfDay'>Medio día</TwinTrans></span >
    }
    if (allRowData?.journey && allRowData?.journey.flexible){
        return <span><TwinTrans transKey='flexibleTimetable'>Horario flexible</TwinTrans></span >
    }
    let hoursToDo = allRowData.totalMinsToDo
    
    if(allRowData.type === 'totals'){
        hoursToDo = allRowData?.totalMinsToDo || 0
    }
    return (
        <div>
            {displayFormatedHourFromMins(hoursToDo)}
        </div>
    )
}
interface RenderJustifiedHoursProps extends ControlEmployeesRenderProps {
}

export const RenderJustifiedHours: React.FC<RenderJustifiedHoursProps> = ({ allRowData }) => {
    if (!allRowData?.journey && allRowData.type !== 'totals') {
        return <div></div>
    }
    
    let justifiedHours = allRowData.totalJustifiedMins
    
    if(allRowData.type === 'totals'){
        justifiedHours = allRowData?.totalJustifiedMins || 0
    }
    return (
        <div>
            {displayFormatedHourFromMins(justifiedHours)}
        </div>
    )
}
interface RenderBalanceHoursProps extends ControlEmployeesRenderProps {
    permittedTime: boolean
}


export const RenderBalanceHours: React.FC<RenderBalanceHoursProps> = ({ allRowData, permittedTime }) => {
    const now = new Date()
    const dayDate = new Date(allRowData.date)
    if ((!allRowData?.journey && allRowData.type !== 'totals') || now < dayDate) {
        return <div></div>
    }
    let balance = permittedTime ? allRowData?.balancePermitted : allRowData?.balance
    let balanceClassName = 'rounded-xl px-15 py-8 ' + ( balance === 0 ? 'balance_correct' : balance > 0? 'balance_more_hours' : 'balance_less_hours')
    if(allRowData.type === 'totals'){
        balanceClassName ='balance_total ' + ( balance > 0 ? 'balance_total_more_hours' : balance < 0 ? 'balance_total_less_hours' : '')
    }
    return (
        <div className={balanceClassName}>
            {displayFormatedHourFromMins(balance)}
        </div>
    )
}

interface RenderOvertimeHoursProps extends ControlEmployeesRenderProps { }

export const RenderOvertimeHours: React.FC<RenderOvertimeHoursProps> = ({ allRowData }) => {
    if ((!allRowData?.journey && allRowData.type !== 'totals')) {
        return <div></div>
    }
    const overtimeMins = allRowData.totalOvertimeMins || 0
    return (
        <div>
            {displayFormatedHourFromMins(overtimeMins)}
        </div>
    )
}
interface RenderIconBalanceHoursProps extends ControlEmployeesRenderProps {
}


export const RenderIconBalanceHours: React.FC<RenderIconBalanceHoursProps> = ({ allRowData }) => {
    const {t} = useTwinTranslation()
    if (!allRowData?.journey && allRowData.type !== 'totals') {
        return <div></div>
    }
    let error: undefined | string = undefined
    let iconBalance: JSX.Element | null = null
    const dictWorkingTime: TwinDictionary = {}
    if (allRowData?.journey && allRowData?.journey.workingTime) {
        if(allRowData?.timetables){
            for (const timetable of allRowData?.timetables) {
                const startHour =  timetable.edited_start_time || timetable.og_start_time
                const startHourParsed = startHour.split(' ')[1].split(':')
                const startMin = getMinFromHoursMin(startHourParsed[0], startHourParsed[1])
                const endHour =  timetable.edited_end_time || timetable.og_end_time
                if(endHour){
                    const endHourParsed = endHour?.split(' ')[1].split(':')
                    const endMin = getMinFromHoursMin(endHourParsed[0], endHourParsed[1])
                    for (const hours of allRowData?.journey.workingTime) {
                        if(startMin<hours[1] ){
                            if (!dictWorkingTime[hours[0]]){
                                dictWorkingTime[hours[0]] = []
                            }
                            dictWorkingTime[hours[0]].push({startMin, endMin, timeToStart: hours[0], timeToEnd: hours[1]})
                            break
                        }
                    }
                }
            }
        } else if(new Date(allRowData.date) < new Date()) {
            iconBalance = <IconBalanceNotWorkedError error={t('notWorked', 'No ha trabajado ')} date={allRowData.date} />
        }
    }
    for (const key in dictWorkingTime) {
        const work = dictWorkingTime[key]
        if(work.length){
            for (let i = 0; i < work.length; i++) {
                const element = work[i]
                if (i === 0 && (element.startMin < (element.timeToStart - allRowData.marginStartMin) || element.startMin > (element.timeToStart + allRowData.marginStartMin))) {
                    error = t('issuesInTimetable', 'Incidencia en el horario')
                }
                if (i === (work.length-1) && (element.endMin < (element.timeToEnd - allRowData.marginEndMin) || element.endMin > (element.timeToEnd + allRowData.marginEndMin))){
                    error = t('issuesInTimetable', 'Incidencia en el horario')
                }
            }
        }
    }
    if (error){
        iconBalance = <IconBalanceError error={error} date={allRowData.date} />
    }
    if (allRowData?.type === 'absenceDay' || allRowData?.type === 'absenceJustifiedDay'){
        iconBalance = <IconAbsence type={allRowData?.type} schedule={allRowData?.absenceWorkingTime} date={allRowData.date} />
    }
    return (
        <div>
            {iconBalance}
        </div>
    )
}
interface RenderIconBalanceHoursPermittedProps extends ControlEmployeesRenderProps {
}


export const RenderIconBalanceHoursPermitted: React.FC<RenderIconBalanceHoursPermittedProps> = ({ allRowData }) => {
    const {t} = useTwinTranslation()
    if (!allRowData?.journey && allRowData.type !== 'totals') {
        return <div></div>
    }
    let error: undefined | string = undefined
    let iconBalance: JSX.Element | null = null
    const dictWorkingTime: TwinDictionary = {}
    if (allRowData?.journey && allRowData?.journey.workingTime) {
        if (allRowData?.workingTimePermitted){
            for (const workingTimePermitted of allRowData?.workingTimePermitted) {
                const startMin = workingTimePermitted[0]
                const endMin = workingTimePermitted[1]
                for (const hours of allRowData?.journey.workingTime) {
                    if(startMin<hours[1] ){
                        if (!dictWorkingTime[hours[0]]){
                            dictWorkingTime[hours[0]] = []
                        }
                        dictWorkingTime[hours[0]].push({startMin, endMin, timeToStart: hours[0], timeToEnd: hours[1]})
                        break
                    }
                }
            }
        } else if(new Date(allRowData.date) < new Date()) {
            iconBalance = <IconBalanceNotWorkedError error={t('notWorked', 'No ha trabajado ')} date={allRowData?.date} />
        }
    }
    for (const key in dictWorkingTime) {
        const work = dictWorkingTime[key]
        if(work.length){
            for (let i = 0; i < work.length; i++) {
                const element = work[i]
                if (i === 0 && (element.startMin < (element.timeToStart - allRowData.marginStartMin) || element.startMin > (element.timeToStart + allRowData.marginStartMin))) {
                    error = t('issuesInTimetable', 'Incidencia en el horario')
                }
                if (i === (work.length-1) && (element.endMin < (element.timeToEnd - allRowData.marginEndMin) || element.endMin > (element.timeToEnd + allRowData.marginEndMin))){
                    error = t('issuesInTimetable', 'Incidencia en el horario')
                }
            }
        }
    }
    if (error){
        iconBalance = <IconBalanceError error={error} date={allRowData.date} />
    }
    if (allRowData?.type === 'absenceDay' || allRowData?.type === 'absenceJustifiedDay'){
        iconBalance = <IconAbsence type={allRowData?.type} schedule={allRowData?.absenceWorkingTime} date={allRowData?.date} />
    }
    return (
        <div>
            {iconBalance}
        </div>
    )
}

interface IconBalanceErrorProps {
    error: string
    date: string
}

const IconBalanceError: React.FC <IconBalanceErrorProps> = ({error, date}) => {
    return (
        <div className='icon_balance_error_container flex items-center cursor-pointer relative'>
            <TwinIconToolTip message={error} id={date} icon={faAlarmExclamation} className='text-orange-DE' classNameIcon='h-20' />
        </div>
    )
}
interface IconBalanceNotWorkedErrorProps {
    error: string
    date: string
}

const IconBalanceNotWorkedError: React.FC <IconBalanceNotWorkedErrorProps> = ({error, date}) => {
    return (
        
        <div className='icon_balance_error_container flex items-center cursor-pointer relative'>
            <TwinIconToolTip message={error} id={date} icon={faTriangleExclamation} className='text-red-BA' classNameIcon='h-20'/>
        </div>
    )
}

interface IconAbsenceProps {
    type: string
    schedule?: number[][]
    date: string
}
const IconAbsence: React.FC<IconAbsenceProps> = ({ type, schedule, date}) => {
    const {t} = useTwinTranslation()
    const abscenceMsg: TwinDictionary= {
        absenceDay: t('nonJustifiedAbsenceApproved', 'Ausencia no justificada validada'),
        absenceJustifiedDay: t('justifiedAbsenceApproved', 'Ausencia justificada validada' )
    }
    const { getScheduleText } = useIconAbsenceLogic()
    const isAllDay = schedule?.[0]?.[0] === 0 && schedule?.[0]?.[1] === 0
    const scheduleText = getScheduleText(isAllDay ? [] : schedule || [])
    const messageToolTip = `${abscenceMsg[type]}: \n${scheduleText}`
    return (
        <div className='icon_balance_error_container flex items-center cursor-pointer relative'>
            <TwinIconToolTip message={messageToolTip} id={date} icon={faCheck} classNameIcon='h-20 text-green-43' classNameTooltip='max-w-300 preserve-breaks'/>
        </div>
    )
}

const useIconAbsenceLogic = () => {
    const { t } = useTwinTranslation()
    const messageAllDay = t('allDay', 'Todo el día')
    const getScheduleText = useCallback((schedule: number[][]) => {
        const scheduleArr: string[] = []
        for (const mySchedule of schedule || []) {
            const parsedStartHours = displayFormatedHourFromMins(mySchedule[0])
            const parsedEndHours = displayFormatedHourFromMins(mySchedule[1])
            scheduleArr.push(parsedStartHours + ' - ' + parsedEndHours)
        }
        if (!scheduleArr.length) {
            scheduleArr.push(messageAllDay)
        }
        return (
            scheduleArr.join("\n")
        )
    }, [messageAllDay])

    return { getScheduleText }
}

interface RenderIconShowLocationTimetablesProps extends ControlEmployeesRenderProps {
    setOpenModal: SetEditDeleteModalTy
    date: string
}

export const RenderIconShowLocationTimetables: React.FC<RenderIconShowLocationTimetablesProps> = ({ allRowData, date, setOpenModal }) => {
    if ((!allRowData?.journey && allRowData.type !== 'totals') || allRowData?.type === 'noWorkDay' || (allRowData?.type === 'holidayDay' && !allRowData.isHalfDay) || allRowData?.type === 'totals' || !allRowData?.timetables) {
        return <div></div>
    }

    return (
        <div onClick={() => setOpenModal({type: 'edit', allRowData: {date}})} className='cursor-pointer'>
            <TwinIcon icon={faEye} />
        </div>
    )
}